const checkUserRole = (vm, ...roles) => {
    roles = roles.flat()
    const userRole = vm.$auth?.watch?.data?.role || vm.auth?.watch?.data?.role
    return roles.includes(userRole)
}

const userHasRole = (...roles) => {
    return checkUserRole(Vue, ...roles)
}

const userIsAdmin = () => {
    return checkUserRole(Vue, ['admin'])
}

const userIsAdminOperator = () => {
    return checkUserRole(Vue, ['admin', 'operator', 'operator-buhgalter'])
}

const userIsOrganizer = () => {
    return checkUserRole(Vue, ['organizer'])
}

const userIsUser = () => {
    return checkUserRole(Vue, ['user'])
}

exports.userHasRole = userHasRole
exports.userIsAdmin = userIsAdmin
exports.userIsAdminOperator = userIsAdminOperator
exports.userIsOrganizer = userIsOrganizer
exports.userIsUser = userIsUser
